var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('layout',[_c('v-card',{attrs:{"elevation":"3"}},[_c('v-card-text',{staticClass:"d-flex justify-center align-center pa-10"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }